import { render } from "./environments.vue?vue&type=template&id=b14796d2"
import script from "./environments.vue?vue&type=script&lang=ts"
export * from "./environments.vue?vue&type=script&lang=ts"
script.render = render

export default script